import { useCallback } from 'react';
import useTelemetry from './use-telemetry';
import {
  AuthenticationSource,
  LoginSuccessEventCreateInput,
} from '../graph/schema-generated-types-educator';
import { TelemetryEvents } from '../types';

type FireEventProps = Partial<Pick<LoginSuccessEventCreateInput, 'sessionId' | 'classroomId'>>;

const useLoginSuccessTelemetry = (authenticationSource: AuthenticationSource) => {
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.LOGIN_SUCCESS);

  const fireLoginSuccessEvent = useCallback(
    ({ sessionId, classroomId }: FireEventProps) => {
      fireEvent({
        authenticationSource,
        sessionId,
        classroomId,
      });
    },
    [authenticationSource, fireEvent]
  );

  return fireLoginSuccessEvent;
};

export default useLoginSuccessTelemetry;
